import React from 'react';
import { useEventSummary } from './useEventSummary';

export function useEventId() {
  const { event } = useEventSummary();

  return React.useMemo(() => event?.id || '', [event?.id]);
}
